import { render, staticRenderFns } from "./BaseDivider.vue?vue&type=template&id=f21dddd6&scoped=true&"
import script from "./BaseDivider.vue?vue&type=script&lang=js&"
export * from "./BaseDivider.vue?vue&type=script&lang=js&"
import style0 from "./BaseDivider.vue?vue&type=style&index=0&id=f21dddd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21dddd6",
  null
  
)

export default component.exports